import { Flex, Box, Button } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormRadioGroup } from '../forms/integrated-form-controls/form-radio-group';
import { FormSection } from '../search-windows/form-section';
import { EventSearchFormType } from './types';

export function EventSearchFormSelfInitiatedSection({
    form,
    options,
}: {
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
}) {
    return (
        <FormSection title="Self Initiated" testId="self-initiated-section">
            <Flex flexFlow="wrap" gap="1rem" flex={1} alignItems="center">
                <Box>
                    <FormRadioGroup
                        name="selfInitiated"
                        items={options.selfInitiatedOptions}
                        control={form.control}
                    />
                </Box>
                <Button variant="ghost" onClick={() => form.resetField('selfInitiated')}>
                    Clear
                </Button>
            </Flex>
        </FormSection>
    );
}
